import React from 'react';
import '../static/css/gqlmotion.css';

const GQLMotion = ({ animate,size })=>(
    <div
        style={{
            width: `${size}px`,
            height: `${size}px`,
            backgroundColor: 'rgba(0,0,0,0)',
            position: 'relative'
        }}
    >
        {/* outer links */}
        <div
            id={(animate) ? "outer1" : null}
            style={{
                position:'absolute',
                left:'calc(50% - 2.6958024%)',
                top:'calc(9.75% - 2.075% + 10.0608714%)',
                width:'40.2434855%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(30deg)'
            }} />
        <div
            id={(animate) ? "outer2" : null}
            style={{
                position:'absolute',
                left:'calc(84.85% - 2.075%)',
                top:'29.875%',
                width:'4.15%',
                height:'40.25%',
                backgroundColor:'#E535AB'
            }} />
        <div
            id={(animate) ? "outer3" : null}
            style={{
                position:'absolute',
                left:'calc(84.825% - 37.5041658%)',
                top:'calc(70.125% - 2.075% + 10.0492109%)',
                width:'40.1968438%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(150deg)'
            }} />
        <div
            id={(animate) ? "outer4" : null}
            style={{
                position:'absolute',
                left:'calc(50% - 37.5091368%)',
                top:'calc(90.2% - 2.075% - 10.0505429%)',
                width:'40.2021717%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(210deg)'
            }} />
        <div
            id={(animate) ? "outer5" : null}
            style={{
                position:'absolute',
                left:'calc(15.1775% - 2.075%)',
                top:'calc(70.125% - 40.25%)',
                width:'4.15%',
                height:'40.25%',
                backgroundColor:'#E535AB',
                transform:'rotate(180deg)'
            }} />
        <div
            id={(animate) ? "outer6" : null}
            style={{
                position:'absolute',
                left:'calc(15.1775% - 2.6942073%)',
                top:'calc(29.875% - 2.075% - 10.0549184%)',
                width:'40.2434855%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(-30deg)'
            }} />

        {/* inner links */}
        <div
            id={(animate) ? "inner1" : null}
            style={{
                position:'absolute',
                left:'calc(50% - 17.4246974%)',
                top:'calc(9.75% - 2.075% + 30.1804611%)',
                width:'69.6987895%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(60deg)'
            }} />
        <div
            id={(animate) ? "inner2" : null}
            style={{
                position:'absolute',
                left:'calc(84.825% - 69.6475%)',
                top:'calc(70.125% - 2.075%)',
                width:'69.6475%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(180deg)'
            }} />
        <div
            id={(animate) ? "inner3" : null}
            style={{
                position:'absolute',
                left:'calc(15.1775% - 17.4211368%)',
                top:'calc(70.11% - 2.075% - 30.174294%)',
                width:'69.6987895%',
                height:'4.15%',
                backgroundColor:'#E535AB',
                transform:'rotate(-60deg)'
            }} />

        {/* circles */}
        <div
            id={(animate) ? "circle1" : null}
            style={{
                borderRadius:'50%',
                position:'absolute',
                left:'calc(50% - 8.74%)',
                top:'calc(9.75% - 8.74%)',
                width:'17.49%',
                height:'17.49%',
                backgroundColor:'#E535AB'
            }} />
        <div
            id={(animate) ? "circle2" : null}
            style={{
                borderRadius:'50%',
                position:'absolute',
                left:'calc(84.85% - 8.74%)',
                top:'calc(29.875% - 8.74%)',
                width:'17.49%',
                height:'17.49%',
                backgroundColor:'#E535AB'
            }} />
        <div
            id={(animate) ? "circle3" : null}
            style={{
                borderRadius:'50%',
                position:'absolute',
                left:'calc(84.825% - 8.74%)',
                top:'calc(70.125% - 8.74%)',
                width:'17.49%',
                height:'17.49%',
                backgroundColor:'#E535AB'
            }} />
        <div
            id={(animate) ? "circle4" : null}
            style={{
                borderRadius:'50%',
                position:'absolute',
                left:'calc(50% - 8.74%)',
                top:'calc(90.2% - 8.74%)',
                width:'17.49%',
                height:'17.49%',
                backgroundColor:'#E535AB'
            }} />
        <div
            id={(animate) ? "circle5" : null}
            style={{
                borderRadius:'50%',
                position:'absolute',
                left:'calc(15.1775% - 8.74%)',
                top:'calc(70.11% - 8.74%)',
                width:'17.49%',
                height:'17.49%',
                backgroundColor:'#E535AB'
            }} />
        <div
            id={(animate) ? "circle6" : null}
            style={{
                borderRadius:'50%',
                position:'absolute',
                left:'calc(15.1775% - 8.74%)',
                top:'calc(29.875% - 8.74%)',
                width:'17.49%',
                height:'17.49%',
                backgroundColor:'#E535AB'
            }} />
    </div>
)

export default GQLMotion;